// extracted by mini-css-extract-plugin
module.exports = {"hireUS":"hire-us_hireUS__ww6qM","heading":"hire-us_heading__1POvy","subHeading":"hire-us_subHeading__wnJMN","last":"hire-us_last__3Ic5s"};